import { bandScore } from "@/lib/score";
import { Zap, Siren, ChevronRight } from "lucide-react";
import { HAZARD_LABEL } from "@/lib/hazard";

// Top-of-screen urgency bar: surfaces ONLY broadcast-ready threats — unexplained
// anomalies forecast to cross their alert level within 24h. Hidden when there are none.
export const LeadTimeBanner = ({ alerts = [], onSelect, onOpen }) => {
  const items = alerts.filter((a) => a.broadcast_eligible);
  if (!items.length) return null;
  const loop = items.length < 4 ? items.concat(items, items) : items.concat(items);

  return (
    <div
      className="h-8 shrink-0 flex items-center bg-atlas-red/15 border-b border-atlas-red/40 overflow-hidden"
      data-testid="lead-time-banner"
    >
      <button
        onClick={onOpen}
        data-testid="lead-time-label"
        className="flex items-center gap-1.5 px-3 h-full border-r border-atlas-red/40 shrink-0 text-atlas-red hover:bg-atlas-red/20 transition-colors"
      >
        <Siren className="w-3.5 h-3.5 atlas-pulse" />
        <span className="text-[10px] font-mono font-bold uppercase tracking-widest">
          Escalating &lt;24h · {items.length}
        </span>
      </button>

      <div className="flex-1 overflow-hidden">
        <div className="flex items-center gap-10 whitespace-nowrap ticker-scroll">
          {loop.map((a, i) => (
            <button
              key={a.uid + "-" + i}
              onClick={() => onSelect && onSelect(a)}
              className="flex items-center gap-2 text-[11px] font-mono text-atlas-foreground/90 hover:text-white transition-colors"
            >
              <Zap className="w-3 h-3 text-atlas-orange" />
              <span className="text-atlas-red font-semibold">[{HAZARD_LABEL[a.hazard] || a.hazard}]</span>
              <span className="text-white/90">{a.region}</span>
              <span className="text-atlas-secondary/80">{a.lead_time || "forecast to cross the alert level within 24h"}</span>
              <span className="text-atlas-cyan">{Math.round(bandScore(a).v * 100)}%</span>
              <ChevronRight className="w-3 h-3 text-atlas-red/50" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
